<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>云影像查询</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 新闻列表 -->
    <div  style="width: 100%;height: auto;background-color: white;margin-top: 20px;">
      <div style="padding-top: 20px;margin-bottom: 20px; text-align: center;line-height: 30px;font-size:18px">{{rqxs}} 访问数据</div>
      <el-table size="small" :header-cell-style="{background:'#00A0FF',color:'white',border: '1px solid tan'}"
    :row-class-name="tableRowClassName"  :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 30px;margin: 0 auto;">
         <el-table-column align="center" type="index" width="60" >
         </el-table-column>

         <el-table-column prop="openid" align="center" label="微信openid" width="300">
         </el-table-column>
        <el-table-column prop="patientname" align="center" label="姓名" width="300">
        </el-table-column>
        <el-table-column prop="idcard" align="center" label="身份证号" width="300">
        </el-table-column>
        <el-table-column prop="count" align="center" label="访问次数" width="300">
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="日期" width="300">
        </el-table-column>




      <!--   <el-table-column fixed="right" label="操作" align="center" width="100">
           <template slot-scope="scope">
             <router-link :to="{ path: '/news/article/'+scope.row.id }" type="text" size="small">编辑</router-link>
             <el-button @click="deleteNews(scope.row.id)" type="text" size="small" style="margin-left: 10px;">删除</el-button>
           </template>
         </el-table-column> -->
       </el-table>

    </div>

    <!-- 分页组件 -->
<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <div style="width: 100%;height: 60px;">

    </div>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { yyxlist,updateNews,delNews, yyxdetail,yyxfwdetail} from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 30,
          date:''
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 30,
          total: 30
        },
        tjsj:{},
        listData: [], //表格数据
        rqxs:''
      }
    },
    components:{
      Pagination
    },
    created() {

     // let date = this.$route.params.date;
      this.formInline.date = this.$route.params.date;
      this.rqxs = this.$route.params.date;
      //console.log(date)
       this.getdata(this.formInline)
    },
    methods: {
      getdata(parameter) {
        this.loading = true
        yyxdetail(parameter).then(res => {
           // console.log(res)
            this.loading = false
            this.listData = res.data

            // 分页赋值
             this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        ).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      tableRowClassName({ row, rowIndex }) {
              if (rowIndex % 2 === 1) {
                return 'success-row' //这是类名
              } else  {
                return ''
              }
        },
        cxqx(row,status){

            console.log(row)
            this.$router.push('/yyx/yyxdetail/'+row.date); //jkcpxx


        }
    }
  }
</script>

<style>
  .jiahong{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/yyx/yyxdetail.vue